<template>
  <div>
    <navbar></navbar>
  </div>
</template>

<script>
  import navbar from "../components/mobile/navbar";

  export default {
    name: "mobileIndex",
    components: {
      navbar
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/mobileIndex.vue